import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import {
  FavoriteCategories,
  FavoriteCategory,
  FavoriteCategoryService,
} from "@/api";

export type CompanyDirectoryState = {
  favoriteCategories?: FavoriteCategories | undefined;
};

const state: CompanyDirectoryState = {
  favoriteCategories: undefined,
};

const getters: GetterTree<CompanyDirectoryState, RootState> = {
  favoriteCategories: state => state.favoriteCategories,
};

const mutations: MutationTree<CompanyDirectoryState> = {
  SET_FAVORITE_CATEGORIES: (state, favoriteCategories) => {
    state.favoriteCategories = favoriteCategories;
  },
};

const actions: ActionTree<CompanyDirectoryState, RootState> = {
  fetchFavoriteCategories: async ({ commit, rootState }) => {
    const companyId = rootState.appContext.company?.id;
    if (companyId) {
      try {
        const favoriteCategories = await FavoriteCategoryService.getFavoriteCategory(
          {
            companyId,
          },
        );
        commit("SET_FAVORITE_CATEGORIES", favoriteCategories);
      } catch (error) {
        if (error instanceof Error) {
          commit("alert/SET_SHOW_ERROR", error.message, { root: true });
        }
      }
    }
  },
  addFavoriteCategory: async (
    { commit, rootState, dispatch },
    requestBody: FavoriteCategory,
  ) => {
    const companyId = rootState.appContext.company?.id;
    if (companyId) {
      try {
        await FavoriteCategoryService.addFavoriteCategory({
          companyId,
          requestBody,
        });
        dispatch("fetchFavoriteCategories");
      } catch (error) {
        if (error instanceof Error) {
          commit("alert/SET_SHOW_ERROR", error.message, { root: true });
        }
      }
    }
  },
  updateFavoriteCategory: async (
    { commit, rootState, dispatch },
    requestBody: FavoriteCategory,
  ) => {
    const companyId = rootState.appContext.company?.id;
    if (companyId) {
      try {
        await FavoriteCategoryService.updateFavoriteCategory({
          companyId,
          requestBody,
        });
        dispatch("fetchFavoriteCategories");
      } catch (error) {
        if (error instanceof Error) {
          commit("alert/SET_SHOW_ERROR", error.message, { root: true });
        }
      }
    }
  },
  deleteFavoriteCategory: async (
    { commit, rootState, dispatch },
    requestBody: FavoriteCategory,
  ) => {
    const companyId = rootState.appContext.company?.id;
    if (companyId) {
      try {
        FavoriteCategoryService.deleteFavoriteCategory({
          companyId,
          requestBody,
        });
        dispatch("fetchFavoriteCategories");
      } catch (error) {
        if (error instanceof Error) {
          commit("alert/SET_SHOW_ERROR", error.message, { root: true });
        }
      }
    }
  },
};

export const favoriteCategory: Module<CompanyDirectoryState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
